// Role page v2 content (wave 1). First GENERATED Sep 23 2026 by Maeve's gen_v2.py; since Oct 2026 edited in place
// (breadth pass Oct 23 2026: audience cards, 5th prompt, 3 FAQs). Keep FAQ = visible list (FAQPage JSON-LD).
/* eslint-disable */
const content = {
 "slug": "ai-content-creator",
 "roleDisplay": "AI Content Creator",
 "phrase": "ai content creator",
 "seo": {
  "title": "AI Content Creator: Videos, Graphics, Podcasts | CellCog",
  "description": "An AI content creator that makes the media: short videos with captions, social graphics, podcast episodes and the posts that go with them."
 },
 "painSub": "You have more ideas than finished content, because every video, graphic and episode needs hours of production. Your AI content creator turns one brief into the finished set, ready for your review.",
 "definition": "An AI content creator is an AI employee that produces finished media: short videos with captions, social graphics, thumbnails, podcast episodes and the posts that go with them. On CellCog they are hired in minutes, work in your brand style, and research what performs in your niche with the agent ranked #1 on DeepResearch Bench (October 2026).",
 "panes": [
  {
   "num": "01 · DRAFT",
   "title": "Writes the draft.",
   "sub": "A blog post or a script, drafted from one brief and ready for your review.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--doc\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Blog draft</span></div><div class=\"rf-body\"><div class=\"rf-doc\"><div class=\"rf-doc-page\"><b class=\"rf-doc-t\">5 stretches for desk-bound hips</b><span class=\"rf-doc-m\">Blog draft · 780 words · waiting for your review</span><p>If you sit for most of the day, your hips feel it first. These five stretches take ten minutes, need no mat and fit between meetings.</p><b class=\"rf-doc-h\">1. Low lunge with a reach</b><p>Step one foot forward, lower the back knee and lift both arms. Hold for five slow breaths, then switch sides.</p><b class=\"rf-doc-h\">2. Seated figure four</b><p>Cross one ankle over the opposite knee and sit tall. Lean forward only as far as your breath stays easy.</p><b class=\"rf-doc-h\">3. Standing quad pull</b><p>Hold a chair for balance and draw one heel toward your seat. Keep your knees side by side.</p><b class=\"rf-doc-h\">4. Wall calf stretch</b><p>Press both hands into a wall and step one foot back. Keep the heel down and hold for five breaths.</p></div></div></div></div></div>"
  },
  {
   "num": "02 · MEDIA",
   "title": "Makes the media.",
   "sub": "Short videos, graphics and thumbnails in your brand style, sized for each platform.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--gallery\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Media</span></div><div class=\"rf-body\"><div class=\"rf-head\"><b>This week&#x27;s media</b><span>2 videos, 4 images</span></div><div class=\"rf-gallery\"><figure class=\"rf-tile\"><div class=\"rf-thumb rf-tone-pink\"><span class=\"rf-thumb-k\">Reel</span><span class=\"rf-play\"><svg viewBox=\"0 0 24 24\" width=\"14\" height=\"14\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M8 5v14l11-7z\"/></svg></span><span class=\"rf-dur\">0:32</span></div><figcaption><b>3 hip openers</b><span>For Instagram</span></figcaption></figure><figure class=\"rf-tile\"><div class=\"rf-thumb rf-tone-accent\"><span class=\"rf-thumb-k\">Image</span></div><figcaption><b>October class schedule</b><span>Post and story sizes</span></figcaption></figure><figure class=\"rf-tile\"><div class=\"rf-thumb rf-tone-purple\"><span class=\"rf-thumb-k\">Image</span></div><figcaption><b>Quote card: breathe first</b><span>For the newsletter</span></figcaption></figure><figure class=\"rf-tile\"><div class=\"rf-thumb rf-tone-orange\"><span class=\"rf-thumb-k\">Video</span><span class=\"rf-play\"><svg viewBox=\"0 0 24 24\" width=\"14\" height=\"14\" fill=\"currentColor\" aria-hidden=\"true\"><path d=\"M8 5v14l11-7z\"/></svg></span><span class=\"rf-dur\">0:45</span></div><figcaption><b>Studio tour</b><span>For YouTube</span></figcaption></figure><figure class=\"rf-tile\"><div class=\"rf-thumb rf-tone-blue\"><span class=\"rf-thumb-k\">Image</span></div><figcaption><b>Blog header: desk hips</b><span>Matches the draft</span></figcaption></figure><figure class=\"rf-tile\"><div class=\"rf-thumb rf-tone-green\"><span class=\"rf-thumb-k\">Image</span></div><figcaption><b>Workshop poster, Oct 18</b><span>Print and email</span></figcaption></figure></div></div></div></div>"
  },
  {
   "num": "03 · MEMORY",
   "title": "Keeps your style.",
   "sub": "Your colors, fonts, past videos and voice notes live in your Drive, so each piece matches.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--drive\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Drive</span></div><div class=\"rf-body\"><div class=\"rf-drive\"><div class=\"rf-crumb\"><span>Drive</span><i aria-hidden=\"true\">/</i><span>Lantern Yoga</span><i aria-hidden=\"true\">/</i><b>Content</b></div><ul class=\"rf-files\"><li class=\"rf-file\"><span class=\"rf-ficon rf-t-pdf\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">PDF file</span></span><span class=\"rf-fname\">Brand look and voice.pdf</span><span class=\"rf-fmeta\">Colors, fonts, words</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-dir\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z\"/></svg><span class=\"rf-sr\">Folder</span></span><span class=\"rf-fname\">Class photos</span><span class=\"rf-fmeta\">140 files</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-doc\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><path d=\"M10 9H8\"/><path d=\"M16 13H8\"/><path d=\"M16 17H8\"/></svg><span class=\"rf-sr\">Document</span></span><span class=\"rf-fname\">Blog ideas.docx</span><span class=\"rf-fmeta\">22 ideas, ranked</span></li><li class=\"rf-file\"><span class=\"rf-ficon rf-t-img\"><svg viewBox=\"0 0 24 24\" width=\"18\" height=\"18\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" aria-hidden=\"true\"><path d=\"M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z\"/><path d=\"M14 2v4a2 2 0 0 0 2 2h4\"/><circle cx=\"10\" cy=\"12\" r=\"2\"/><path d=\"m20 17-1.09-1.09a2 2 0 0 0-2.82 0L10 22\"/></svg><span class=\"rf-sr\">Image</span></span><span class=\"rf-fname\">Logo files</span><span class=\"rf-fmeta\">Added by you</span></li></ul><div class=\"rf-remember\"><b>Remembered</b><p>Calm, never preachy, real students only with their permission, and every video ends on the class schedule.</p></div></div></div></div></div>"
  },
  {
   "num": "04 · APPROVALS",
   "title": "Asks before anything is posted.",
   "sub": "Each piece waits for your yes. Approve, edit or skip.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--approval\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">Approvals</span></div><div class=\"rf-body\"><div class=\"rf-appr\"><div class=\"rf-appr-card\"><span class=\"rf-appr-h\"><i aria-hidden=\"true\"></i>Waiting for your yes</span><p class=\"rf-appr-q\">Publish the hip openers reel on Instagram?</p><div class=\"rf-prev\"><div class=\"rf-prev-h\"><img src=\"https://logos.composio.dev/api/instagram\" alt=\"\" width=\"16\" height=\"16\"><span>Instagram</span><em>Lantern Yoga</em></div><b class=\"rf-prev-t\">3 hip openers for desk days</b><p class=\"rf-prev-b\">Ten minutes, no mat, between meetings. Save this for tomorrow and tag a friend who sits too much.</p></div><div class=\"rf-appr-b\"><span class=\"rf-btn-y\">Approve</span><span class=\"rf-btn\">Edit</span><span class=\"rf-btn\">Skip</span></div></div><div class=\"rf-queue\"><span class=\"rf-queue-h\">2 more waiting</span><ul><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Blog post: 5 stretches for desk-bound hips</span><span class=\"rf-q-m\">Website · draft ready</span></li><li><i aria-hidden=\"true\"></i><span class=\"rf-q-t\">Studio tour video for YouTube</span><span class=\"rf-q-m\">YouTube · 0:45</span></li></ul></div></div></div></div></div>"
  },
  {
   "num": "05 · REPORTS BACK",
   "title": "Shows you the batch.",
   "sub": "What they made, what is scheduled and which pieces are waiting for your review.",
   "slideCls": "rolp-v2-slide",
   "frameHtml": "<div class=\"rf-wrap\"><div class=\"aie-fb__frame rf-frame rf-frame--report\"><div class=\"aie-fb__bar\"><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"aie-fb__dot\"></span><span class=\"rf-bartitle\">End of day report</span></div><div class=\"rf-body\"><div class=\"rf-report\"><div class=\"rf-rep-h\"><b>Lantern content</b><span>Today, 6:00 pm</span></div><div class=\"rf-stats\"><div class=\"rf-stat\"><b>2</b><span>videos made</span></div><div class=\"rf-stat\"><b>4</b><span>images</span></div><div class=\"rf-stat\"><b>1</b><span>blog draft</span></div></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--done\">Done</span><ul><li>Made the hip openers reel and the studio tour</li><li>Designed 4 images for the week</li><li>Drafted the desk hips blog post</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--next\">Next</span><ul><li>Record voiceover for the breathing video</li><li>Write the October newsletter</li><li>Plan the workshop promo</li></ul></div><div class=\"rf-rrow\"><span class=\"rf-rk rf-rk--need\">Needs you</span><ul><li>Review the blog draft before Friday</li></ul></div></div></div></div></div>"
  }
 ],
 "capabilities": [
  {
   "title": "Produces short videos",
   "body": "Scripted, generated, edited and captioned, ready to post."
  },
  {
   "title": "Designs graphics and thumbnails",
   "body": "Carousels, quote cards and thumbnails in your brand style, sized per platform."
  },
  {
   "title": "Makes podcast episodes",
   "body": "Narration and full episodes with an intro and outro, from a topic or a document."
  },
  {
   "title": "Plans the content calendar",
   "body": "Themes, hooks and dates for the month, adjusted to what performs."
  },
  {
   "title": "Repurposes one piece into many",
   "body": "A webinar becomes clips, posts, an article and an email."
  },
  {
   "title": "Tracks what performs",
   "body": "Reads the numbers on what you posted and suggests the next round."
  }
 ],
 "steps": [
  {
   "n": "01",
   "title": "Hire in one line.",
   "body": "\"Hire a content creator. Two short videos and three carousels a week about our product.\""
  },
  {
   "n": "02",
   "title": "Share your style.",
   "body": "Add your brand kit and a few pieces you like to your Drive."
  },
  {
   "n": "03",
   "title": "Approve the first batch.",
   "body": "They send the first videos and graphics. You approve, edit or skip each one."
  }
 ],
 "tools": [
  {
   "name": "YouTube",
   "logo": "https://logos.composio.dev/api/youtube"
  },
  {
   "name": "Instagram",
   "logo": "https://logos.composio.dev/api/instagram"
  },
  {
   "name": "LinkedIn",
   "logo": "https://logos.composio.dev/api/linkedin"
  },
  {
   "name": "X",
   "logo": "https://logos.composio.dev/api/twitter"
  },
  {
   "name": "Canva",
   "logo": "https://logos.composio.dev/api/canva"
  },
  {
   "name": "Google Drive",
   "logo": "https://logos.composio.dev/api/googledrive"
  },
  {
   "name": "Notion",
   "logo": "https://logos.composio.dev/api/notion"
  },
  {
   "name": "Slack",
   "logo": "https://logos.composio.dev/api/slack"
  }
 ],
 "control": {
  "statement": "Nothing is posted without your yes.",
  "sub": "They make the content.",
  "accent": "You decide what goes live.",
  "rows": [
   {
    "title": "Review before publishing",
    "body": "Each piece waits for your approval by default."
   },
   {
    "title": "You set what they may post alone",
    "body": "Approve a kind of post in advance and keep the rest on approval."
   },
   {
    "title": "Everything visible",
    "body": "Every script, asset and post sits on one board you can read any time."
   }
  ]
 },
 "wont": {
  "sub": "They make your content.",
  "accent": "Some things stay off limits.",
  "rows": [
   {
    "title": "No filming you",
    "body": "They can't point a camera at you; they build around your footage or none."
   },
   {
    "title": "No posting where AI content is banned",
    "body": "They flag platforms and communities whose rules restrict it."
   },
   {
    "title": "No publishing without your yes",
    "body": "Every post waits for approval unless you approve a kind in advance."
   }
  ]
 },
 "comparison": {
  "title": "Three ways to make content",
  "cols": [
   "Doing it yourself",
   "A design app",
   "AI Content Creator"
  ],
  "rows": [
   {
    "label": "Writes the script",
    "cells": [
     "You",
     "No",
     "Yes"
    ]
   },
   {
    "label": "Makes the video",
    "cells": [
     "You, with editing software",
     "Templates you fill",
     "Generated and edited"
    ]
   },
   {
    "label": "Makes graphics and thumbnails",
    "cells": [
     "You",
     "You, with templates",
     "Yes, in your style"
    ]
   },
   {
    "label": "Makes podcast episodes",
    "cells": [
     "You record and edit",
     "No",
     "Yes"
    ]
   },
   {
    "label": "Turns one piece into many",
    "cells": [
     "You",
     "No",
     "Yes"
    ]
   },
   {
    "label": "Asks before publishing",
    "cells": [
     "n/a",
     "n/a",
     "Yes, by default"
    ]
   }
  ]
 },
 "prompts": [
  {
   "q": "Take this customer case study and turn it into a 60-second video with captions, three quote graphics, and a LinkedIn post.",
   "deliverable": "a full content package from one source"
  },
  {
   "q": "Plan next month's content calendar around our product launch: two posts a week, one video a week, themes and hooks included.",
   "deliverable": "a complete content calendar"
  },
  {
   "q": "Turn our latest blog post into a 5-minute podcast episode with an intro and outro.",
   "deliverable": "a produced podcast episode"
  },
  {
   "q": "Make 6 thumbnail options for this video, each testing a different hook.",
   "deliverable": "thumbnail options ready to test"
  },
  {
   "q": "Our competitor just launched. Draft a same-day response post with a comparison graphic.",
   "deliverable": "a timely post with a designed graphic"
  }
 ],
 "faq": [
  {
   "q": "What is an AI content creator?",
   "a": "An AI content creator is an AI employee that produces finished media: short videos with captions, social graphics, thumbnails, podcast episodes and the posts that go with them."
  },
  {
   "q": "What can they actually make?",
   "a": "Short and long videos with captions, graphics and carousels sized per platform, thumbnails, narration and podcast episodes, and blog posts. One brief can return a coordinated set."
  },
  {
   "q": "Are they an AI video creator too?",
   "a": "Yes. As an AI video creator they script, generate, edit and caption short videos, and build around your own footage or avatar when you give them one."
  },
  {
   "q": "How are they different from an AI content writer?",
   "a": "A writer produces words. An AI content creator produces the media: the video, the graphic, the episode, and the words around them."
  },
  {
   "q": "Can they publish to our channels?",
   "a": "Yes, through the channels you connect, and every post waits for your approval by default. Where a platform restricts AI-generated content, your AI content creator tells you."
  },
  {
   "q": "Will the quality hold up?",
   "a": "You review everything first, and they learn from what you approve, edit or reject, so later pieces need fewer notes."
  },
  {
   "q": "Are they an AI content creator for social media?",
   "a": "Yes. Most of what they make is for social: short vertical videos, carousels, graphics and the captions that go with them. They also write blog posts and produce podcast episodes.",
   "link": {
    "label": "See the AI Social Media Manager",
    "href": "/ai-employees/ai-social-media-manager"
   }
  },
  {
   "q": "Is an AI content creator a good fit for a small business?",
   "a": "Yes. Give them your brand, your products and a few examples you like, and they keep a steady flow of finished content coming for you to approve."
  },
  {
   "q": "Can I try an AI content creator for free?",
   "a": "Yes. Every new account gets 200 free credits, and no credit card is needed to sign up. Use them to hire your AI content creator and try a first task."
  },
  {
   "q": "What does an AI content creator cost?",
   "a": "__COST_FAQ__"
  },
  {
   "q": "How do I get started?",
   "a": "Click \"Get started\" to sign up and hire your AI Content Creator in minutes, or use \"Talk to us\" and our team will help you set them up."
  }
 ],
 "ctaBand": {
  "title": "Put your AI Content Creator to work today",
  "body": "Send them one piece of source material and get back the video, the graphics, and the posts to carry it."
 },
 "audience": {
  "title": "Who hires an AI content creator",
  "cards": [
   {
    "badge": "Solo founders",
    "title": "A content engine of one",
    "body": "Video, graphics and posts on a real calendar, from one brief, so a company of one publishes like a team."
   },
   {
    "badge": "Small businesses",
    "title": "A full content calendar",
    "body": "Owners get a steady flow of short videos, graphics and posts made from their own products, ready to approve."
   },
   {
    "badge": "Mid-size companies",
    "title": "More output for the marketing team",
    "body": "A multi-format pipeline that keeps running while the team ships launches and campaigns."
   },
   {
    "badge": "Agencies",
    "title": "Content for every client",
    "body": "Video, graphics and posts for many clients in parallel, each in its own brand and voice."
   },
   {
    "badge": "Coaches and creators",
    "title": "Expertise turned into content",
    "body": "One talk or article turned into short clips, quote graphics, posts and a podcast episode."
   },
   {
    "badge": "E-commerce brands",
    "title": "Product content for every launch",
    "body": "Product videos, carousels and thumbnails for each launch, in your brand style."
   }
  ]
 }
};

export default content;
